/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import {
  UsdcLogo,
  XsgdLogo,
  XidrLogo,
  UsdtLogo,
  XusdLogo,
  ThreeDotsLogo,
  UsdLogo,
  SgdLogo,
} from '@xfers/design-system'
import { CURRENCY } from '~/types'

export const getStablecoinIcon = (currency: CURRENCY, size?: string): JSX.Element | undefined => {
  const defaultSize = '1em'
  const props = {
    width: size || defaultSize,
    height: size || defaultSize,
  }
  switch (currency) {
    case CURRENCY.XSGD:
      return <XsgdLogo {...props} />
    case CURRENCY.XIDR:
      return <XidrLogo {...props} />
    case CURRENCY.USDC:
      return <UsdcLogo {...props} />
    case CURRENCY.USDT:
      return <UsdtLogo {...props} />
    case CURRENCY.XUSD:
      return <XusdLogo {...props} />
    case CURRENCY.USDP:
      return <ThreeDotsLogo {...props} />
    case CURRENCY.SGD:
      return <SgdLogo {...props} />
    case CURRENCY.USD:
      return <UsdLogo {...props} />
    default:
      return undefined
  }
}

export const shouldConvertToLocalAmount = (currency: CURRENCY) => {
  const isRegionalCurrency = [CURRENCY.XSGD, CURRENCY.XIDR]
  return isRegionalCurrency.includes(currency)
}
